"use client";

import { TransitionLink } from "@/components/shared/TransitionLink";
import { useDict } from "@/components/providers/LocaleProvider";
import LocaleSwitcher from "./LocaleSwitcher";
import NavBookMeetingButton from "./NavBookMeetingButton";

type NavActionsProps = {
  variant: "compact" | "desktop";
  className?: string;
};

export default function NavActions({ variant, className = "" }: NavActionsProps) {
  const t = useDict();

  return (
    <div className={`flex items-center gap-2 shrink-0 ${className}`}>
      <LocaleSwitcher />
      {variant === "desktop" && (
        <TransitionLink
          href="/faq"
          className="text-white hidden min-[1470px]:block w-[120px] text-center"
        >
          {t.nav.faqShort}
        </TransitionLink>
      )}
      <NavBookMeetingButton variant={variant} />
    </div>
  );
}
